// @flow
import { createSelector } from "reselect";

const selectCropSources: Object => Object = createSelector(
	(state: Object) => (state.cropWidget && state.cropWidget.cropSources ? state.cropWidget.cropSources : {}),
	(cropSources) => cropSources,
);

const selectCrop: Object => Object = createSelector(
	(state: Object) => state.cropWidget.crop,
	(crop) => crop,
);

const selectDefaultCrop: Object => Object = createSelector(
	(state: Object) => state.cropWidget.defaultCrop,
	(defaultCrop) => defaultCrop,
);

const selectShowSkipCropButton = (state: Object) => state.widgetConfig.showSkipCropButton;

const selectCropOptions: Object => Object = createSelector(
	(state: Object) => state.widgetConfig.croppingShowBackButton,
	(state: Object) => state.widgetConfig.croppingAspectRatio,
	(state: Object) => state.widgetConfig.croppingShowDimensions,
	(state: Object) => state.widgetConfig.croppingCoordinatesMode,
	(state: Object) => state.widgetConfig.croppingDefaultSelectionRatio,
	(state: Object) => state.widgetConfig.minImageWidth,
	(state: Object) => state.widgetConfig.minImageHeight,
	(state: Object) => state.widgetConfig.maxImageWidth,
	(state: Object) => state.widgetConfig.maxImageHeight,
	(state: Object) => state.widgetConfig.cropping,
	(
		croppingShowBackButton,
		croppingAspectRatio,
		croppingShowDimensions,
		croppingCoordinatesMode,
		cropDefaultSelectSize,
		minImageWidth,
		minImageHeight,
		maxImageWidth,
		maxImageHeight,
		cropping,
	) => ({
		croppingShowBackButton,
		croppingAspectRatio,
		croppingShowDimensions,
		croppingCoordinatesMode,
		cropDefaultSelectSize,
		minImageWidth,
		minImageHeight,
		maxImageWidth,
		maxImageHeight,
		cropping,
	}),
);

export {
	selectCropSources,
	selectCrop,
	selectDefaultCrop,
	selectCropOptions,
	selectShowSkipCropButton,
};
